import { MdShoppingBag, MdReceipt, MdAccountBalance, MdPayment, MdInventory, MdAdd } from "react-icons/md";

const compras = {
  id: 'compras-group',
  type: 'group',
  roles: [1,100,110,200,400,300],
  breadcrumbs: false,
  children: [
    {
      id: 'compras',
      title: "Compras",
      type: 'collapse',
      icon: MdShoppingBag,
      children: [
        {
          id: 'nueva-orden',
          title: "Nueva Orden",
          type: 'item',
          breadcrumbs: false,
          icon: MdAdd,
          url: '/compras/nueva-orden',
          roles: [1,100,110,200,400,300]
        },
        {
          id: 'ordenes-compra',
          title: "Órdenes de compra",
          type: 'item',
          breadcrumbs: false,
          icon: MdShoppingBag,
          url: '/compras/ordenes',
          roles: [1,100,110,200,400,300]
        },
        {
          id: 'recepcion-mercancia',
          title: "Recepción de mercancía",
          type: 'item',
          breadcrumbs: false,
          icon: MdInventory,
          url: '/compras/recepcion-mercancia',
          roles: [1,100,110,200,400,300]
        },
        {
          id: 'facturas',
          title: "Facturas",
          type: 'item',
          breadcrumbs: false,
          icon: MdReceipt,
          url: '/compras/facturas',
          roles: [1,100,110,300]
        },
        {
          id: 'CxP',
          title: "Cuentas por Pagar",
          type: 'item',
          breadcrumbs: false,
          icon: MdAccountBalance,
          url: '/compras/CxP',
          roles: [1,100,110,400]
        },
        {
          id: 'pagos',
          title: "Pagos",
          type: 'item',
          breadcrumbs: false,
          icon: MdPayment,
          url: '/compras/pagos',
          roles: [1,100,110,400]
        }
      ]
    }
  ]
};

export default compras;
